import { Col, Row } from "reactstrap";
import SwitchItem from "./common/SwitchItem";
import { PrivacyData } from "../../../../../data/pages/Other";
import { Href } from "../../../../../constants";

const Privacy = () => {
  return (
    <Row>
      <Col xs="12">
        <div className="common-card">
          {PrivacyData.map((item, index) => (
            <div className="white-card" key={index}>
              <h4 className="dashboard-title">{item.title}</h4>
              {item.switchItem.map((switchItem, index) => (
                <SwitchItem title={switchItem.title} description={switchItem.description} checked={switchItem.checked ? true : false} key={index} />
              ))}
              <a href={Href} className="btn-solid">
                {item.btnLabel}
              </a>
            </div>
          ))}
        </div>
      </Col>
    </Row>
  );
};

export default Privacy;
